import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_STATISTICS_REQUEST,
    FETCH_STATISTICS_SUCCESS,
    FETCH_STATISTICS_FAILURE,
} from '../actions/statisticsActions';
import { getStatistics } from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

/**
 * Saga pour récupérer les statistiques
 */
function* fetchStatisticsSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getStatistics, params);
        yield put({ type: FETCH_STATISTICS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des statistiques');
        yield put({ type: FETCH_STATISTICS_FAILURE, payload: errorMessage });
    }
}

/**
 * Watcher pour les actions de statistiques
 */
export function* watchStatisticsRequests() {
    yield takeEvery(FETCH_STATISTICS_REQUEST, fetchStatisticsSaga);
}

